export default function (resource, type = false) {
    let types = ['hydrate', 'add', 'remove', 'update', 'reset', 'load', 'set'];

    if(type){
        if(types.indexOf(type) > -1){
            return resource+'.'+type;
        }
        throw Error('Action type not found');
    }

    let r = {};

    for(let type of types){
        r[type] = resource+'.'+type;
    }

    return r;
}